@if (isVisible() && resumeData.oilCollectionTab()) {
  <!-- ── Section 1: Collection Summary ── -->
  <div class="kite-section-card">
    <div class="kite-section-title flex-wrap gap-2">
      <span>Collection Summary</span>
      <div class="section-actions d-flex align-items-center gap-2">
        <app-button size="sm" variant="secondary" (onClick)="exportPDF()" placement="top" container="body" ngbTooltip="It requires choosing a range to be able to be exported">
          <i class="pr-1 fa fa-file-pdf-o" aria-hidden="true"></i>
          @if (!loadingReport()) {
            <span>Generate PDF</span>
          } @else {
            <span>Loading...</span>
          }
        </app-button>

        <app-button size="sm" variant="secondary" (onClick)="sendByEmail()" placement="top" container="body" ngbTooltip="This function automatically sends an email to the customer with their collection dates">
          <i class="pr-1 fa fa-send" aria-hidden="true"></i>
          <span>Send by email</span>
        </app-button>
      </div>
    </div>

    <div class="row align-items-end g-2 mt-1">
      <app-read-only-field label="Total Collected" class="col-xl-3 col-lg-3 col-md-4 mb-2" [align]="'center'" [value]="resumeData.oilCollectionTab()?.grossCollected | number:'1.2-2'"></app-read-only-field>

      <app-read-only-field label="Total clean oil" class="col-xl-3 col-lg-3 col-md-4 mb-2" [align]="'center'" [value]="resumeData.oilCollectionTab()?.grossClean | number:'1.2-2'"></app-read-only-field>

      <app-read-only-field label="First collected date" class="col-xl-3 col-lg-3 col-md-4 mb-2" [value]="resumeData.oilCollectionTab()?.firstCollectionDate | date:'EEEE, MMMM d, y h:mm a'"></app-read-only-field>

      <div class="col-xl-3 col-lg-3 col-md-12 mb-2 d-flex justify-content-lg-end align-items-end">
        <app-date-filter (filterChange)="onDateFilterChange($event)"></app-date-filter>
      </div>
    </div>
  </div>

  <!-- ── Section 2: Collection History ── -->
  <div class="kite-section-card">
    <div class="kite-section-title flex-wrap gap-2">
      <span>Collection History</span>
    </div>
    <div class="w-100 position-relative">
      <!-- Tier 2: wj-flex-grid + app-custom-paginator → app-kite-grid (incluye paginator) -->
      <app-kite-grid
        [columnDefs]="columnDefs"
        [rowData]="pagedCollections()"
        [totalRecords]="collections().length"
        [pageSize]="pageSize"
        (pageChange)="refreshData($event)">
      </app-kite-grid>
    </div>
  </div>
}
